import React, { Fragment } from 'react';

const sameCategory = (item, index, array) => index > 0 && array[index-1].modelKey === array[index].modelKey || item.showAll;

const QuickSearchResult = ({ result, selectedItem, searchUrl }) => (
    <ul className="quick-search-result">
        {result && result.map((item, index, array) => (
            <Fragment key={`${item.name}-${index}`}>

                {
                    item.category === 'NoHit' || sameCategory(item, index, array) 
                    ? null
                    : <li className="quick-search-result__item quick-search-result__group-header" >{ item.category }</li>
                }


                <li className={`quick-search-result__item ${selectedItem === index ? 'quick-search-result__item--selected' : ''}`} >
                    {
                        item.modelKey === "Products"
                        ? (
                            <a className={item.showAll ? 'quick-search-result__show-all' : `quick-search-result__link ${item.url ? '' : 'quick-search-result__link--disabled'}`} 
                                href={item.showAll ? searchUrl :item.url}>
                                {item.hasImage && item.imageSource && <img className="quick-search-result__image" src={item.imageSource} />}
                                <div>{item.name}</div>
                            </a>
                        )
                        : (
                            <div className={item.showAll ? 'quick-search-result__show-all' : `quick-search-result__link ${item.url ? '' : 'quick-search-result__link--disabled'}`} 
                                >
                                {item.hasImage && item.imageSource && <img className="quick-search-result__image" src={item.imageSource} />}
                                <div><QuickSearchResultUrl item={item}/></div>
                            </div>
                         )
                    }
                </li>
            </Fragment>
        ))}
    </ul>
    
)

const QuickSearchResultUrl = (props) =>{
    const {item} = props
    return <>
    {
        item.url !== undefined  &&  item.url !== null && item.url.includes('/') && item.url.split('/').length > 1
        ? 
            <>
                {
                    item.url.split('/').filter(x => x !== "").map( (x, index, array) => {
                        var link = array.slice(0,index + 1);
                        return (
                            <Fragment key={x}>
                            <a href={`/${link.join('/')}`} key={x}  className="category-link"> {x.replace('-','&')} </a>
                            {
                                index + 1 !== array.length
                            ?   <>{" > "}</>
                            :   null}
                            </Fragment>
                        )
                    })
                }
            </>
        : item.name
    }
    </>
}

export default QuickSearchResult;